"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const prefersReducedMotion = useRef(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      prefersReducedMotion.current = mediaQuery.matches;
      const handleScroll = () => {
        if (!prefersReducedMotion.current) {
          setScrollY(window.scrollY);
        }
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  const parallaxOffset = prefersReducedMotion.current ? 0 : scrollY * 0.5;
  return <section ref={ref} className="relative w-full h-screen overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-0" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/commercial_building_exterior.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-black/30" />

      {}
      <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {}
          <h1 className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 transition-all ${isVisible && !prefersReducedMotion.current ? "animate-fade-in-up" : isVisible ? "opacity-100" : "opacity-0"}`}>
            Expert Commercial HVAC Solutions
          </h1>

          {}
          <p className={`font-sans text-lg sm:text-xl md:text-2xl text-white/90 mb-8 transition-all ${isVisible && !prefersReducedMotion.current ? "animate-fade-in-up-delay-100" : isVisible ? "opacity-100" : "opacity-0"}`}>
            Precision climate control for Pennsylvania businesses
          </p>

          {}
          <div className={`transition-all ${isVisible && !prefersReducedMotion.current ? "animate-fade-in-up-delay-200" : isVisible ? "opacity-100" : "opacity-0"}`}>
            <Button asChild size="lg" className={`px-8 py-4 text-lg font-semibold shadow-medium ${prefersReducedMotion.current ? "hover:opacity-90" : "hover:-translate-y-0.5 hover:shadow-strong active:translate-y-0"} transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]`}>
              <Link to="/ContactPage">
                Get a Free Consultation
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}